import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  alignContent: "center",
  justifyContent: "flex-end",
  gap: "$md",
  flexGrow: 1,
  padding: "$md"
});